import React, { useState } from "react";
import {
  DatePicker as MuiDatePicker,
  DatePickerProps as MuiDatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { endOfYear, startOfYear } from "date-fns";
import { CustomTextField } from "./CustomPicker";

type Props = Omit<MuiDatePickerProps<Interval, Interval>, "renderInput">;

export const YearPicker = ({
  label = "Select Year",
  value,
  onChange,
}: Props) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date(value?.start ?? "")
  );

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);

    const interval: Interval = {
      start: startOfYear(date),
      end: endOfYear(date),
    };

    onChange(interval);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDatePicker
        value={selectedDate}
        label={label}
        views={["year"]}
        openTo="year"
        inputFormat="yyyy"
        renderInput={(params) => (
          <CustomTextField
            {...params}
            variant="outlined"
            inputProps={{ ...params.inputProps, readOnly: true }}
            InputLabelProps={{ shrink: true }}
            margin="dense"
            size="small"
          />
        )}
        onChange={(e) => handleDateChange(e as Date)}
      />
    </LocalizationProvider>
  );
};
